import { render } from "./feedbackForm.vue?vue&type=template&id=64a2d254&scoped=true"
import script from "./feedbackForm.vue?vue&type=script&lang=js"
export * from "./feedbackForm.vue?vue&type=script&lang=js"

import "./feedbackForm.vue?vue&type=style&index=0&id=64a2d254&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a2d254"]])

export default __exports__